import * as React from 'react'

import Image from '../../atoms/Image'
import Paragraph from '../../atoms/Paragraph'
import './style.css'

interface Props {
  content?: any
  isArticle?: boolean
}

/**
 * TwoColumnArticle Component
 * @param content - Content from the CMS.
 * @param isArticle (optional) - To render article layout
 */

const TwoColumnArticle = ({ content, isArticle }: Props) => {
  return (
    <>
      <div className={`layoutSpacing twocol`}>
        <div className={`layout sectionBottomSpacing w-full`}>
          <div
            className={`flex w-100 flex-col flex-wrap justify-between md:flex-row ${isArticle ? '' : 'md:w-75 xl:w-60'}`}
          >
            <div
              className={`${content?.imagePosition ? 'order-2 mt-24 md:mt-0 md:pl-24' : 'order-1 mb-24 md:mb-0 md:pr-24'} md:w-[49%]`}
            >
              <Paragraph content={content?.description} />
            </div>
            <div
              className={`${content?.imagePosition ? 'order-1 mb-24 md:mb-0 md:pr-24' : 'order-2 mt-24 md:mt-0 md:pl-24'} md:w-[49%]`}
            >
              <Image
                imageUrl={content?.image?.fields?.file?.url}
                altText={content?.image?.fields?.description}
                caption={content?.captionText}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TwoColumnArticle
